module.exports = __webpack_public_path__ + "PTMETTAlogo-1.4e520d5d.png";